// Toasts, sonner's API in miniature: toast("Saved") anywhere, one <Toaster />
// at the root. A message that matters stays in the page; a toast is only
// news that something finished.
import { useEffect, useState } from "preact/hooks";

type Toast = { id: number; title: string; description?: string; variant?: "default" | "error"; ms: number };
let next = 1;
const listeners = new Set<(t: Toast[]) => void>();
let toasts: Toast[] = [];
const emit = () => listeners.forEach((l) => l(toasts));

export function toast(title: string, o: { description?: string; variant?: "default" | "error"; ms?: number } = {}) {
  const t: Toast = { id: next++, title, description: o.description, variant: o.variant, ms: o.ms ?? 4000 };
  toasts = [...toasts, t];
  emit();
  setTimeout(() => { toasts = toasts.filter((x) => x !== t); emit(); }, t.ms);
  return t.id;
}
toast.error = (title: string, o: { description?: string; ms?: number } = {}) => toast(title, { ...o, variant: "error" });

export function Toaster() {
  const [list, setList] = useState<Toast[]>(toasts);
  useEffect(() => { listeners.add(setList); return () => { listeners.delete(setList); }; }, []);
  return (
    <ol class="ui-toaster" aria-live="polite" aria-label="Notifications">
      {list.map((t) => (
        <li key={t.id} class="ui-toast" data-variant={t.variant}>
          <div class="ui-toast-body">
            <div class="ui-toast-title">{t.title}</div>
            {t.description && <div class="ui-toast-description">{t.description}</div>}
          </div>
        </li>
      ))}
    </ol>
  );
}
